
import { SearchOutlined, CaretDownOutlined, ExclamationCircleOutlined } from '@ant-design/icons-vue'
import { computed, createVNode, defineComponent, inject, onMounted, reactive, ref } from 'vue';
import Organization from './comp/Organization.vue'
import SeniorSearch from './comp/SeniorSearch.vue'
import AccountTable from './comp/AccountTable.vue'
import ModalEditGroup from './comp/ModalEditGroup.vue'
import ModalEdit from './comp/ModalEdit.vue'
import ModalExportExcel from './comp/ModalExportExcel.vue'
import ModalImport from './comp/ModalImport.vue'
import OpenEngineerApi from '@/api/OpenEngineerApi';
import OpenProviderApi from '@/api/OpenProviderApi';
import router from '@/router';
import { message, Modal } from 'ant-design-vue';

const defaultQuery = JSON.stringify({
  name: '',
  email: '',
  phone: '',
  roleId: null,
  serviceDeskId: null,
  defaultServiceDeskId: null,
  searchKey: '',
  searchType: 'EARCHKEYQUERY',
  status: null,
  externalId: ''
})

export default defineComponent({
  name: 'AccountManage',
  components: {
    SearchOutlined,
    CaretDownOutlined,
    Organization,
    AccountTable,
    SeniorSearch,
    ModalEdit,
    ModalEditGroup,
    ModalExportExcel,
    ModalImport
  },
  setup () {
    const visible = reactive({
      search: false,
      edit: false,
      editGroup: false,
      export: false,
      import: false
    })
    const wrapRef = ref<HTMLDivElement>();
    const tabRef = ref<HTMLDivElement>()
    const tableRef = ref()
    const seniorRef = ref()
    const cacheQuery = localStorage.getItem('engineer_senior_search')
    const engineerQuery = cacheQuery ? reactive(JSON.parse(cacheQuery)) : reactive(JSON.parse(defaultQuery))
    const hasPermission: any = inject('hasPermission')
    const searchKey = ref(engineerQuery.searchKey)
    const selectedRows = ref<Array<any>>([])
    const menuWithNotSelect = computed(() => {
      let list = [
        { permission: 'engieer_create', name: '添加客服', fun: handleAdd },
        { permission: 'engineer_export', name: '导出Excel', fun: () => handleShowModal('export') },
        { permission: 'engineer_import', name: '批量导入', fun: () => handleShowModal('import') }
      ]
      if (hadSunloginWeb.value) {
        list = [
          { permission: 'engineer_export', name: '导出Excel', fun: () => handleShowModal('export') }
        ]
      }
      return list.filter(item => hasPermission.value(item.permission))
    })

    const menuWithSelected = computed(() => {
      let list = [
        { permission: 'engieer_delete', name: '批量删除', fun: handleDelete },
        { permission: 'engieer_update', name: '批量修改', fun: () => handleShowModal('edit') },
        { permission: 'engieer_update', name: '编辑部门', fun: () => handleShowModal('editGroup') },
        { permission: 'engieer_update', name: '启用账号', fun: () => handleEditStatus(true) },
        { permission: 'engieer_update', name: '停用账号', fun: () => handleEditStatus(false) }
      ]
      // 有向日葵服务时，隐藏批量删除和编辑部门
      if (hadSunloginWeb.value) {
        list = list.filter((item, index) => ![0, 2].includes(index))
      }
      return list.filter(item => hasPermission.value(item.permission))
    })

    const showClear = computed(() => {
      if (selectedRows.value.length > 0) return false
      if (searchKey.value) return true
      const { name, email, phone, roleId, defaultServiceDeskId, status, externalId, serviceDeskId } = engineerQuery
      if (name || email || phone || roleId || defaultServiceDeskId || status || status === 0 || externalId || serviceDeskId) return true
      return false
    })

    function handleSearch () {
      engineerQuery.searchKey = searchKey.value
      engineerQuery.searchType = 'EARCHKEYQUERY'
    }

    function handleSeniorSearch (query) {
      visible.search = false;
      Object.assign(engineerQuery, query)
    }

    function handleClear () {
      if (seniorRef.value) {
        seniorRef.value.handleClear()
      }
      Object.assign(engineerQuery, JSON.parse(defaultQuery))
      searchKey.value = ''
    }

    function handleCancel () {
      selectedRows.value = []
    }
    // 刷新列表
    function handleRefresh () {
      tableRef.value.loadData()
    }

    function handleAdd () {
      router.push({
        path: '/system_setting/account-add/detail'
      })
    }

    function handleDelete () {
      Modal.confirm({
        title: () => '确认要删除选中的客服吗？',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: '确定',
        cancelText: '取消',
        onOk () {
          const ids = selectedRows.value.map(row => row.id).join(',')
          OpenEngineerApi.deleteEngineers({
            ids
          }).then(() => {
            message.success('已删除')
            selectedRows.value = []
            tableRef.value.loadData()
          })
        }
      })
    }

    function handleShowModal (type: string) {
      visible[type] = true
    }

    function handleEditStatus (isEnable: boolean) {
      const list = selectedRows.value.filter(item => {
        return isEnable ? item.user?.status === 0 : item.user?.status === 1
      });
      if (list.length === 0) {
        message.error('您选中的客服，都为' + (isEnable ? '启用' : '停用') + '或待激活状态，请重新选择。')
        return
      }
      Modal.confirm({
        title: () => '确认要' + (isEnable ? '启用' : '停用') + '选中的客服吗？',
        icon: () => createVNode(ExclamationCircleOutlined),
        okText: '确定',
        cancelText: '取消',
        onOk () {
          const ids = list.map(row => row.id)
          OpenEngineerApi.batchEnable({
            engineerIds: ids,
            enabled: isEnable
          }).then(() => {
            message.success(isEnable ? '已启用' : '已停用')
            selectedRows.value = []
            tableRef.value.loadData()
          })
        }
      })
    }
    // 向日葵服务
    const hadSunloginWeb = ref<boolean>(false)
    function getProviderLicense () {
      OpenProviderApi.getProviderLicense().then(res => {
        hadSunloginWeb.value = res.moduleList && res.moduleList.includes('sunlogin_web')
      })
    }

    onMounted(() => {
      getProviderLicense()
    })
    return {
      visible,
      selectedRows,
      tabRef,
      seniorRef,
      wrapRef,
      tableRef,
      searchKey,
      engineerQuery,
      menuWithNotSelect,
      menuWithSelected,
      showClear,
      handleSearch,
      handleSeniorSearch,
      handleClear,
      handleCancel,
      handleRefresh,
      handleShowModal,
      handleEditStatus,
      hadSunloginWeb
    }
  }
})
